import { Link } from "react-router-dom";

export const ProductCard = ({ product, priority = false }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      className="group block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-image-wrap aspect-[3/4] bg-muted/40 overflow-hidden">
        {product.images?.[0] ? (
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover"
            loading={priority ? "eager" : "lazy"}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs uppercase tracking-widest">No Image</div>
        )}
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="serif text-xl font-light">{product.name}</h3>
          <div className="overline text-muted-foreground mt-1">{product.category}</div>
        </div>
        <div className="text-sm font-light mt-1">${product.price.toFixed(0)}</div>
      </div>
    </Link>
  );
};
